import type { AppMessage } from '@/composables/useSamGpt/types'

export const hasBody = (message: AppMessage) => !!message.body?.length || !!message.passiveRecommendations

export const hasSuggestedMessages = (message: AppMessage) => !!message.suggestedMessages?.messages?.length

export const hasOutstandingRecommendation = (message: AppMessage) => !!message.outstandingRecommendation

export const hasPassiveRecommendations = (message: AppMessage) => !!message.passiveRecommendations

export const hasPassiveRecommendationsWithImages = (message: AppMessage) => !!message.passiveRecommendationsWithImages

export const hasRecommendations = (message: AppMessage) => message.recommendations?.length
